// extracted by mini-css-extract-plugin
export var fullWidth = "noResults-module--fullWidth--eaf56";
export var wrapper = "noResults-module--wrapper--cec17";